export interface NormalizedError {
  code: string | number;
  message: string | undefined;
}

// PLAY-5095 shape: prefer the server business code, then the HTTP status, then the
// transport code. `||` (not `??`) is deliberate, so an empty code falls through.
export function normalizeError(error: unknown): NormalizedError {
  const err = (error !== null && typeof error === "object" ? error : {}) as {
    response?: { status?: number; data?: { code?: string; message?: string } };
    code?: string;
    message?: string;
  };
  const { status, data } = err.response || {};
  return {
    code: data?.code || status || err.code || "UNKNOWN_ERROR",
    message: data?.message || err.message,
  };
}

// The single seam for caught errors: one console.warn, no state change, never throws.
export function logError(context: string, error: unknown): void {
  try {
    console.warn(`[lobby] ${context}`, normalizeError(error), error);
  } catch {
    // expected: a broken console must never turn a handled failure into a crash
  }
}
